import React, { useRef, useState } from "react";

import * as S from "./styles";
import Button from "components/Button";
import { useEffect } from "react";

export const PasswordPopup = ({
  onClick,
  text,
  slug,
  visibility,
  setVisibility,
  errorMessage,
}) => {
  const [textInput, setTextInput] = useState(Array.from({ length: 6 }));

  const [inputRefs] = useState([
    useRef(),
    useRef(),
    useRef(),
    useRef(),
    useRef(),
    useRef(),
  ]);

  useEffect(() => {
    if (errorMessage) {
      setTextInput(Array.from({ length: 6 }, () => null));

      if (inputRefs[0].current) {
        inputRefs.forEach((ref) => {
          ref.current.value = null;
        });
        inputRefs[0].current.focus();
      }
    }
  }, [errorMessage, inputRefs]);

  const onChangeInput = (value, id) => {
    const nextKey = id + 1;

    const newTextInput = [...textInput];
    newTextInput[id] = value;
    setTextInput(newTextInput);

    if (value.length) {
      if (id === 5) return;
      inputRefs[nextKey].current.focus();
    }
  };

  const handleBack = (evt, id) => {
    const previousKey = id - 1;
    if (evt.key === "Backspace" && id <= 5) {
      if (id > 0) {
        inputRefs[previousKey].current.focus();
      }
    }
  };

  return (
    <S.Container open={visibility} onClose={() => setVisibility(false)} modal>
      {(close) => (
        <>
          <div className="content">
            <div className="top-content">
              <p>Senha do cartão</p>
              <S.CloseIcon onClick={close} />
            </div>

            <div className="input-container">
              {inputRefs.map((e, index) => (
                <input
                  id={`pw-id-${index}`}
                  onChange={(e) => {
                    onChangeInput(e.target.value, index);
                  }}
                  className="input"
                  type="text"
                  inputMode="numeric"
                  ref={e}
                  pattern="[0-9]*"
                  maxLength="1"
                  onKeyUp={(ev) => handleBack(ev, index)}
                />
              ))}
            </div>
          </div>
          {errorMessage && <S.ErrorMessage>{errorMessage}</S.ErrorMessage>}

          <hr />

          <div className="button-container">
            <Button onClick={() => onClick(textInput.join(""))}>{text}</Button>
          </div>
        </>
      )}
    </S.Container>
  );
};

export default PasswordPopup;
